import { render, staticRenderFns } from "./unDraggableTree.vue?vue&type=template&id=e87cb9e4&"
import script from "./unDraggableTree.vue?vue&type=script&lang=ts&"
export * from "./unDraggableTree.vue?vue&type=script&lang=ts&"
import style0 from "./unDraggableTree.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports